import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzInputGroupComponent, NzInputModule } from 'ng-zorro-antd/input';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzBackTopModule } from 'ng-zorro-antd/back-top';
import { NzAffixModule } from 'ng-zorro-antd/affix';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzTreeViewModule } from 'ng-zorro-antd/tree-view';
import { NzTransferModule } from 'ng-zorro-antd/transfer';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { NzTreeSelectModule } from 'ng-zorro-antd/tree-select';
import { NzGridModule } from 'ng-zorro-antd/grid';

export const NzPackages = [
  NzGridModule,
  NzRadioModule,
  NzLayoutModule,
  NzMenuModule,
  NzButtonModule,
  NzSelectModule,
  NzSpinModule,
  NzInputModule,
  NzCheckboxModule,
  NzTableModule,
  NzDatePickerModule,
  NzFormModule,
  NzPopconfirmModule,
  NzDropDownModule,
  NzSwitchModule,
  NzModalModule,
  NzCardModule,
  NzBadgeModule,
  NzTagModule,
  NzAvatarModule,
  NzAlertModule,
  NzSkeletonModule,
  NzSpaceModule,
  NzIconModule,
  NzTabsModule,
  NzTimelineModule,
  NzStepsModule,
  NzUploadModule,
  NzListModule,
  NzToolTipModule,
  NzTimePickerModule,
  NzPaginationModule,
  NzBackTopModule,
  NzAffixModule,
  NzPopoverModule,
  NzTreeViewModule,
  NzTransferModule,
  NzDividerModule,
  NzTreeModule,
  NzTreeSelectModule,
];
